// components/LocationSender.js
import { useEffect, useRef } from 'react';
import api from '../api/axiosConfig';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';

const LocationSender = () => {
  const { token, user } = useAuth();
  const { t } = useTranslation();
  const timerRef = useRef(null);

  useEffect(() => {
    if (!user) return; // токен берём из localStorage через axios interceptor

    const sendLocation = () => {
      if (!navigator.geolocation) return;

      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          try {
            await api.post('location', {
              latitude: pos.coords.latitude,
              longitude: pos.coords.longitude,
              accuracy: pos.coords.accuracy,
              timestamp: new Date().toISOString(),
            });
          } catch (err) {
            console.error(t('location_sender.send_error'), err);
          }
        },
        (err) => {
          console.error(t('location_sender.permission_denied'), err);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    };

    // сразу и по интервалу
    sendLocation();
    timerRef.current = setInterval(sendLocation, 30000);

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [user, t, token]); // token в deps без прямого использования — чтобы пересоздать таймер при логине/логауте

  return null;
};

export default LocationSender;
